package com.r_estrategica.redacaoestrategica.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.document
import kotlinx.browser.window
import kotlin.js.JsExport

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    val root = document.getElementById("screen-container")
    
    // Sincroniza estado inicial se o Firebase já estiver logado
    val windowDynamic: dynamic = window
    
    // Expõe as funções globalmente para o Router.js e app.js
    windowDynamic.notifyFirebaseState = ::notifyFirebaseState
    windowDynamic.notifyScreenChange = ::notifyScreenChange
    
    val auth = windowDynamic.auth
    if (auth != null && auth.currentUser != null) {
        val user = auth.currentUser
        val uid = user.uid?.toString()
        val name = user.displayName?.toString() ?: user.email?.toString()?.split("@")?.get(0)
        if (uid != null) {
            AuthBridge.userUid = uid
            AuthBridge.userName = name ?: "Visitante"
            AuthBridge.currentState = AuthState.LOGADO
        }
    }

    if (root != null) {
        ComposeViewport(root) {
            App()
        }
    }
}

enum class AuthState {
    VERIFICANDO,
    LOGADO,
    DESLOGADO
}

object AuthBridge {
    var currentState by mutableStateOf(AuthState.VERIFICANDO)
    var userUid by mutableStateOf<String?>(null)
    var userName by mutableStateOf<String?>("Visitante")
}

sealed class Screen {
    object Dashboard : Screen()
    object LearningPath : Screen()
    object InterventionGenerator : Screen()
    object AgentesIntervencao : Screen()
    object Sinonimos : Screen()
}

object Navigation {
    var currentScreen by mutableStateOf<Screen>(Screen.Dashboard)
}

@Composable
fun App() {
    val state = AuthBridge.currentState
    val screen = Navigation.currentScreen

    MaterialTheme {
        Surface(modifier = Modifier.fillMaxSize()) {
            when (state) {
                AuthState.VERIFICANDO -> {
                    Box(
                        modifier = Modifier.fillMaxSize(),
                        contentAlignment = Alignment.Center
                    ) {
                        CircularProgressIndicator()
                    }
                }

                AuthState.LOGADO -> {
                    val uid = AuthBridge.userUid ?: ""
                    val nameFromGoogle = AuthBridge.userName ?: "Visitante"
                    
                    // Fallback para isPremium do JS
                    val jsAppState = window.asDynamic().AppState
                    val isPremium = (jsAppState?.user?.plan?.toString() == "premium")

                    // ROTEADOR ESTRUTURAL
                    // Usamos Row para integrar o Sidebar no Compose
                    Row(modifier = Modifier.fillMaxSize()) {
                        
                        // Menu Lateral (Sidebar)
                        SidebarComponent(
                            currentScreen = screen,
                            onNavigate = { Navigation.currentScreen = it }
                        )

                        // CONTÊINER DE NAVEGAÇÃO (ROTEADOR)
                        // IMPORTANTE: Evitamos Modifier.shadow, .blur ou .graphicsLayer aqui
                        // para prevenir o erro org_jetbrains_skia_Paint__1nMake no Skiko
                        Box(
                            modifier = Modifier
                                .weight(1f)
                                .fillMaxHeight()
                                .background(Color(0xFFF8F9FA)) // Fundo neutro
                        ) {
                            when (screen) {
                                is Screen.Dashboard -> DashboardScreen(uid = uid, nameFromGoogle = nameFromGoogle)
                                is Screen.LearningPath -> LearningPathScreen(
                                    isPremium = isPremium,
                                    aoVoltar = { Navigation.currentScreen = Screen.Dashboard }
                                )
                                is Screen.InterventionGenerator -> TelaGeradorIntervencao(
                                    aoClicarVoltar = { Navigation.currentScreen = Screen.Dashboard },
                                    aoClicarAbrirBancoAgentes = { Navigation.currentScreen = Screen.AgentesIntervencao },
                                    aoEnviarParaCorrecao = { /* Integrar com a tela de correcao JS se necessário */ }
                                )
                                is Screen.AgentesIntervencao -> TelaAgentesIntervencao(
                                    aoClicarVoltar = { Navigation.currentScreen = Screen.InterventionGenerator },
                                    aoClicarGerador = { Navigation.currentScreen = Screen.InterventionGenerator },
                                    isPremium = isPremium
                                )
                                is Screen.Sinonimos -> TelaSinonimos(
                                    aoClicarVoltar = { Navigation.currentScreen = Screen.Dashboard },
                                    isPremium = isPremium
                                )
                            }
                        }
                    }
                }

                AuthState.DESLOGADO -> {
                    // Aqui você pode renderizar sua tela de Login em Compose
                    // Ou deixar o overlay do JS cuidar disso.
                    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        Text("Aguardando Login...")
                    }
                }
            }
        }
    }
}

@JsExport
fun notifyScreenChange(screen: String) {
    com.r_estrategica.redacaoestrategica.data.logDebug("Kotlin notifyScreenChange triggered", screen)
    Navigation.currentScreen = when (screen) {
        "learning-path" -> Screen.LearningPath
        "intervention-generator" -> Screen.InterventionGenerator
        "agentes-intervencao" -> Screen.AgentesIntervencao
        "sinonimos" -> Screen.Sinonimos
        else -> Screen.Dashboard
    }
}

@JsExport
fun notifyFirebaseState(isLoggedIn: Boolean, uid: String?, name: String?) {
    com.r_estrategica.redacaoestrategica.data.logDebug("Kotlin notifyFirebaseState triggered", mapOf("logged" to isLoggedIn, "uid" to uid, "name" to name))
    AuthBridge.userUid = uid
    
    // Get the name from parameter or fallback to AppState JS
    val jsAppState = com.r_estrategica.redacaoestrategica.data.AppState
    val fallbackName = jsAppState?.user?.name?.toString()
    
    val finalName = if (!name.isNullOrBlank()) name else fallbackName
    
    AuthBridge.userName = if (!finalName.isNullOrBlank()) finalName else "Visitante"
    AuthBridge.currentState = if (isLoggedIn) AuthState.LOGADO else AuthState.DESLOGADO
}
